import axios from "axios";
import { getApiBaseUrl } from "./endpoints";

export const createApiClient = () => {
  const client = axios.create({
    baseURL: getApiBaseUrl(),
    headers: { "Content-Type": "application/json" },
  });

  return {
    get: (url, config) => client.get(url, config).then((r) => r.data),
    post: (url, data, config) => client.post(url, data, config).then((r) => r.data),
    put: (url, data, config) => client.put(url, data, config).then((r) => r.data),
    delete: (url, config) => client.delete(url, config).then((r) => r.data),
    upload: (url, data, config) =>
      client
        .put(url, data, {
          ...config,
          headers: { ...(config?.headers || {}), "Content-Type": "multipart/form-data" },
        })
        .then((r) => r.data),
    setToken: (token) => {
      client.defaults.headers.common.Authorization = token
        ? `Bearer ${token}`
        : undefined;
    },
  };
};
